<template>
    <div id="newUserCoupon" class="cover">
        <div class="cover_center_panel">
            <img src="./img/newuser/newuser_01.png" alt="" srcset="">
            <img src="./img/newuser/newuser_02.png" alt="" srcset="">
            <img src="./img/newuser/newuser_03.png" alt="" srcset="">
            <img src="./img/newuser/newuser_04.png" alt="" srcset="">
            <img src="./img/newuser/newuser_05.png" alt="" srcset="" @click="recieveNow" style="cursor:pointer;">
            <div class="receive_btn" @click="recieveNow"></div>
            <!-- <img @click="closeCouponPopup" class="close-icon" src="./img/coupon-colse.png" /> -->
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        name:"newUserCoupon",
		props:['showPopup'],
        data() {
            return {
                
            }
        },
        created() {
        
        },
		methods:{
			//关闭优惠券弹窗
			closeCouponPopup(){
				this.$emit('update:showPopup',false)
			},
			//立即领取兑换券
			recieveNow(){
				this.$emit('update:showPopup',false)
				this.$emit("receiveHandle")
                 //埋点
                let user_id = localStorage.getItem("user_id")||0;
                zjzBrowseRecord({user_id:user_id, mod_code:"p008"})
			}
		}
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .cover_center_panel{
        width: 400px;
        padding: 30px 50px 40px;
        img{
            width: 100%;
            display: block;
        }
        .receive_btn{
            position: absolute;
            width: 114px;
            height: 36px;
            top: 420px;
            left: 50%;
            margin-left: -55px;
            cursor: pointer;
        }
		.close-icon{
			position: absolute;
			right: -10px;
			top: -30px;
			height: 25px;
			width: 25px;
            cursor: pointer;
		}
    }
</style>